import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.jsx';
import './index.css';

// Ponto de entrada da aplicação.  Cria a árvore React e monta o
// componente raiz `App` dentro do elemento com id "root" definido em
// index.html.  React.StrictMode ajuda a detectar padrões de código
// problemáticos durante o desenvolvimento.
ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);